module.exports = __webpack_public_path__ + "img/bg_void.c949a151.jpg";